import { render, staticRenderFns } from "./CtrlSwitch.vue?vue&type=template&id=61493cc2"
import script from "./CtrlSwitch.vue?vue&type=script&lang=js"
export * from "./CtrlSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports